import { HttpParams } from '@angular/common/http';
import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LOCATION_SCHEMAS } from '../../common/endpoints';
import { LocationSchema, ProductionLine } from '../../model';
import { HttpService } from '../../service/http.service';


@Injectable()
export class LocationSchemaService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService,
    ) { }

    saveLocationSchema(locationSchema: LocationSchema): Promise<LocationSchema> {
        return firstValueFrom(this.httpService.post<LocationSchema>(LOCATION_SCHEMAS, locationSchema));
    }

    getLocationSchemaByLocationId(locationId: string): Promise<LocationSchema> {
        const params = new HttpParams().set("locationId", locationId);
        return firstValueFrom(this.httpService.get<LocationSchema[]>(LOCATION_SCHEMAS, params)).then(results => {
            return results?.length ? results[0] : null;
        });
    }

    getThingIdsFromLocationSchema(locationSchema: LocationSchema): string[] {
        let result: string[] = [];
        locationSchema.productionLines?.forEach(pl => {
            pl.workCells?.forEach(wc => wc.thingIds?.forEach(id => {
                if (!result.includes(id)) {
                    result.push(id);
                }
            }));
        });
        return result;
    }


    getThingIdsFromProductionLine(productionLine: ProductionLine): string[] {
        let result: string[] = [];
        productionLine.workCells?.forEach(wc => wc.thingIds?.forEach(id => {
            if (!result.includes(id)) {
                result.push(id);
            }
        }));
        return result;
    }

}